import { useAuth } from "@dustin-web/microsite-components/src/auth"
import Button from "@dustin-web/microsite-components/src/button"
import { useSiteContext, useTranslations, useUserSettings } from "@dustin-web/microsite-components/src/hooks"
import { useContext, useEffect } from "react"
import { useFormContext } from "react-hook-form"
import AppContext from "src/appContext"
import { StandardRegisterProps } from "."
import { GaRegEvent } from "src/components/gaRegistrationHook/gaRegistrationEventHook"

const Confirmation = () => {

  const { getValues } = useFormContext<StandardRegisterProps>()
  const { translate } = useTranslations()
  const { returnUrl } = useContext(AppContext)
  const { signIn } = useAuth()
  const { twoLetterISOLanguageName } = useUserSettings()
  const { siteType } = useSiteContext()

  const { completeGaEvent } = GaRegEvent()

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    signIn({
      cancellationUrl: window.location.origin,
      provider: 'okta',
      siteType: siteType === 'Business' ? 'business' : 'consumer',
      username: getValues("email"),
      returnUrl: returnUrl ?? window.location.origin,
      language: twoLetterISOLanguageName,
    })
  }

  useEffect(() => {
    completeGaEvent()
  }, [])
  

  return (
    <div>
      <div className="row">
        <div className="col">
          <h2 className="no-mouseflow-dom">
            {translate("RegisterBuinsess_Thanks_Content", { companyFirstName: getValues("firstName") })}
          </h2>
        </div>
      </div>
      <div className="row u-py-12">
        <div className="col">

          <Button
            primary
            text={translate("RegisterBuinsess_Login")}
            onClick={handleClick}
          />
        </div>
      </div>
    </div>
  )
}

export default Confirmation
